module.exports = __webpack_public_path__ + "img/creative-agency.cc0f79f9.png";